import { lazy } from 'react';
import { RouteConfig } from '@bobex/react-core/routes/RouteConfig';

export const protectedRoutes: RouteConfig[] = [
    {
        key: 'Dashboard',
        path: 'dashboard',
        component: lazy(() => import('@/pages/Dashboard/Dashboard')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Incentives',
        path: 'incentives',
        component: lazy(() => import('@/pages/Incentives/IncentivesPage')),
        authority: ['VIEW_INCENTIVE_DASHBOARD'],
    },
    {
        key: 'Search User',
        path: 'search-user',
        component: lazy(() => import('@/pages/SearchUser/SearchUser')),
        authority: ['READ_USER'],
    },
    {
        key: 'Search invoice',
        path: 'search-invoice',
        component: lazy(() => import('@/pages/SearchInvoice/SearchInvoice')),
        authority: ['READ_INVOICE'],
    },
    {
        key: 'User overview',
        path: 'user/:userId/:tabValue',
        component: lazy(() => import('@/pages/UserDetails/UserDetails')),
        authority: ['READ_USER'],
    },
    {
        key: 'Supplier leads',
        path: 'supplier-leads/:userId',
        component: lazy(() => import('@/pages/SupplierLeads/SupplierLeads')),
        authority: ['READ_USER'],
    },
    {
        key: 'PartnerRfp search',
        path: 'partner-rfp-search-result',
        component: lazy(() => import('@/pages/SearchResult/PartnerRfpSearchResult')),
        authority: ['PARTNER_RFP_SEARCH'],
    },
    {
        key: 'Adminisrator list',
        path: 'administrator-list',
        component: lazy(() => import('@/pages/AdminList/AdminList')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Cost list',
        path: 'cost-list',
        component: lazy(() => import('@/pages/CostList/CostList')),
        authority: ['READ_COST'],
    },
    {
        key: 'Newsletter list',
        path: 'newsletters/:mailType/list',
        component: lazy(() => import('@/pages/NewsletterList/NewsletterList')),
        authority: ['READ_NEWSLETTER'],
    },
    {
        key: 'Supplier Relaunch List',
        path: 'supplier-relaunch',
        component: lazy(() => import('@/pages/SupplierRelaunchList/SupplierRelaunchList')),
        authority: ['READ_SUPPLIER_RELAUNCH'],
    },
    {
        key: 'Free lead invoicing',
        path: 'free-lead-invoicing',
        component: lazy(() => import('@/pages/FreeLeadInvoicing/FreeLeadInvoicing')),
        authority: ['MANAGE_FREE_LEAD_INVOICING'],
    },
    {
        key: 'Twikey mandate export',
        path: 'twikey-mandate-export',
        component: lazy(() => import('@/pages/TwikeyMandateExport/TwikeyMandateExport')),
        authority: ['MANAGE_TWIKEY_EXPORT'],
    },
    {
        key: 'Marketing report import',
        path: 'marketing-report-import',
        component: lazy(() => import('@/pages/MarketingReportImport/MarketingReportImport')),
        authority: ['MANAGE_MARKETING_IMPORT'],
    },
    {
        key: 'Create newsletter',
        path: 'newsletters/:mailType/edit',
        component: lazy(() => import('@/pages/NewsletterList/NewsletterEdit')),
        authority: ['READ_NEWSLETTER'],
    },
    {
        key: 'Edit newsletter',
        path: 'newsletters/:mailType/edit/:newsletterId',
        component: lazy(() => import('@/pages/NewsletterList/NewsletterEdit')),
        authority: ['READ_NEWSLETTER'],
    },
    {
        key: 'Email redlist',
        path: 'email-redlist',
        component: lazy(() => import('@/pages/EmailRedlist/EmailRedlistList')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Sitemap',
        path: 'sitemap',
        component: lazy(() => import('@/pages/Sitemap/Sitemap')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Leads List',
        path: 'leads-list/:languageCode',
        component: lazy(() => import('@/pages/PartnerRfpsWithheldList/PartnerRfpsWithheldList')),
        authority: ['PARTNER_RFP_NEW_PAGES'],
    },
    {
        key: 'Leads List Filtered',
        path: 'leads-list/:languageCode/:filter',
        component: lazy(() => import('@/pages/PartnerRfpsWithheldList/PartnerRfpsWithheldList')),
        authority: ['PARTNER_RFP_NEW_PAGES'],
    },
    {
        key: 'Leads Edit',
        path: 'leads-edit/:id',
        component: lazy(() => import('@/pages/PartnerRfpEdit/PartnerRfpEdit')),
        authority: ['PARTNER_RFP_NEW_PAGES'],
    },
    {
        key: 'External Leads In Process',
        path: 'external-leads-in-process',
        component: lazy(() => import('@/pages/ExternalLeadsInProcessList/ExternalLeadsInProcessList')),
        authority: ['EXTERNAL_LEAD_VIEW'],
    },
    {
        key: 'Search Supplier',
        path: 'search-customers',
        component: lazy(() => import('@/pages/SearchCustomer/SearchCustomer')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Search Assignation Sales',
        path: 'search-assignation-sales',
        component: lazy(() => import('@/pages/SearchAssignationSales/SearchAssignationSales')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Partner registration',
        path: 'partner-registration/:userGroup?',
        component: lazy(() => import('@/pages/PartnerRegistration/PartnerRegistration')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'PartnerRfp Spam List',
        path: 'partnerrfp-spam-list',
        component: lazy(() => import('@/pages/PartnerRfpSpamList/PartnerRfpSpamList')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'My prospects',
        path: 'my-prospects',
        component: lazy(() => import('@/pages/MyProspects/MyProspects')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'My suppliers',
        path: 'my-suppliers',
        component: lazy(() => import('@/pages/MySuppliers/MySuppliers')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Protest controlled by Bobex',
        path: 'protest-controlled-by-bobex',
        component: lazy(() => import('@/pages/ProtestPages/ProtestControlledByBobex')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Protest Low Capping',
        path: 'protest-low-capping',
        component: lazy(() => import('@/pages/ProtestPages/ProtestLowCapping')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Protest Visual Accept',
        path: 'protest-visual-accept',
        component: lazy(() => import('@/pages/ProtestPages/ProtestVisualAccept')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Pdf export task',
        path: 'pdf-export-tasks',
        component: lazy(() => import('@/pages/PdfExportTask/PdfExportTaskListPage')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Business Type Management',
        path: 'business-type-management',
        component: lazy(() => import('@/pages/BusinessTypeManagement/BusinessTypeManagementList')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'ExpertBusType without email',
        path: 'expertBusType-without-email',
        component: lazy(
            () => import('@/pages/ExpertBusTypeWithoutEmail/ExpertBusTypeWithoutEmailListPage')
        ),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'ExpertBusType without price',
        path: 'list-expertbustype-without-price',
        component: lazy(
            () => import('@/pages/ExpertBusTypeWithoutPrice/ExpertBusTypeWithoutPriceListPage')
        ),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Partner submission without price',
        path: 'list-partnersubmission-without-price',
        component: lazy(
            () => import('@/pages/PartnerSubmissionWithoutPrice/PartnerSubmissionWithoutPriceListPage')
        ),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Modulo97 Check List',
        path: 'modulo-97-check-list',
        component: lazy(() => import('@/pages/Modulo97CheckListPage/Modulo97CheckListPage')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Charts Home',
        path: 'charts-home',
        component: lazy(() => import('@/pages/ChartsHome/ChartsHome')),
        authority: ['VIEW_CHARTS'], // VIEW_CHARTS
    },
    {
        key: 'Global KPI',
        path: 'global-kpi',
        component: lazy(() => import('@/pages/GlobalKpi/GlobalKpi')),
        authority: ['VIEW_CHARTS_PLUS'],
    },
    {
        key: 'Holidays List',
        path: 'holidays-list',
        component: lazy(() => import('@/pages/HolidaysList/HolidaysList')),
        authority: ['READ_USER'],
    },
    {
        key: 'Notifications',
        path: 'notifications',
        component: lazy(() => import('@/pages/NotificationList/NotificationList')),
        authority: ['READ_USER'],
    },
    {
        key: 'Partner Premium Capping',
        path: 'partner-premium-capping',
        component: lazy(() => import('@/pages/PartnerPremiumCapping/PartnerPremiumCappingPage')),
        authority: ['READ_USER'],
    },
    {
        key: 'Lijst van alle facturen',
        path: 'invoices/all',
        component: lazy(() => import('@/pages/InvoiceList/AllInvoices')),
        authority: ['READ_INVOICE'],
    },
    {
        key: 'Alle onbetaalde facturen',
        path: 'invoices/unpaid',
        component: lazy(() => import('@/pages/InvoiceList/AllUnpaid')),
        authority: ['READ_INVOICE'],
    },
    {
        key: 'Onbetaalde facturen (buiten betalingstermijn)',
        path: 'invoices/past-due',
        component: lazy(() => import('@/pages/InvoiceList/PastDueInvoices')),
        authority: ['READ_INVOICE'],
    },
    {
        key: 'Onbetaalde facturen Local',
        path: 'invoices/unpaid-local',
        component: lazy(() => import('@/pages/InvoiceList/LocalPremiumUnpaid')),
        authority: ['READ_INVOICE'],
    },
    {
        key: 'Token Manager',
        path: 'token-manager',
        component: lazy(() => import('@/pages/TokenManagerPage/TokenManagerPage')),
        authority: ['MANAGE_TOKENS', 'MANAGE_MEMBER_API_TOKENS'],
    },
    {
        key: 'Send to Lawyer',
        path: 'send-to-lawyer',
        component: lazy(() => import('@/pages/SendToLawyer/SendToLawyer')),
        authority: ['READ_SEND_TO_LAWYER'],
    },
    {
        key: 'User Similarities',
        path: 'user-similarities',
        component: lazy(() => import('@/pages/UserSimilarities/UserSimilarities')),
        authority: ['READ_USER'],
    },
    {
        key: 'Credit Note List',
        path: 'credit-notes',
        component: lazy(() => import('@/pages/CreditNoteList/CreditNoteList')),
        authority: ['READ_CREDIT_NOTE'],
    },
    {
        key: 'SEO Per Site Partner RFP Statistics',
        path: 'seo-partner-rfp-statistics',
        component: lazy(
            () => import('@/pages/SeoPartnerRfpStatisticsPage/SeoPartnerRfpStatisticsPage')
        ),
        authority: ['VIEW_CHARTS'],
    },
    {
        key: 'Affiliate Partner RFP Statistics',
        path: 'affiliate-partner-rfp-statistics',
        component: lazy(
            () => import('@/pages/AffiliatePartnerRfpStatisticsPage/AffiliatePartnerRfpStatisticsPage')
        ),
        authority: ['VIEW_CHARTS'],
    },
    {
        key: 'Affiliate Group RFP Statistics',
        path: 'affiliate-group-rfp-statistics',
        component: lazy(
            () => import('@/pages/AffiliateGroupRfpStatisticsPage/AffiliateGroupRfpStatisticsPage')
        ),
        authority: ['VIEW_CHARTS'],
    },
    {
        key: 'Messages Edit',
        path: 'messages-edit',
        component: lazy(() => import('@/pages/MessagesEdit/MessagesEditList')),
        authority: ['READ_MESSAGE'],
    },
    {
        key: 'SEO Alert Dashboard',
        path: 'seo-alert-dashboard',
        component: lazy(() => import('@/pages/SeoAlertDashboard/SeoAlertDashboard')),
        authority: ['VIEW_CHARTS'],
    },
    {
        key: 'Revenues Per Day Category',
        path: 'revenues-per-day-category',
        component: lazy(
            () => import('@/pages/RevenuesPerDayCategoryPage/RevenuesPerDayCategoryPage')
        ),
        authority: ['VIEW_CHARTS_PLUS'],
    },
    {
        key: 'Partner Submission Bad Email',
        path: 'partner-submission-bad-email',
        component: lazy(() => import('@/pages/PartnerSubmissionBadEmail/PartnerSubmissionBadEmail')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'List Prepaid Partner Experts',
        path: 'list-prepaid-partner-experts',
        component: lazy(() => import('@/pages/ListPrepaidPartnerExperts/ListPrepaidPartnerExpertsPage')),
        authority: ['READ_USER'],
    },
    {
        key: 'Managed Queues',
        path: 'managed-queues',
        component: lazy(() => import('@/pages/ManagedQueues/ManagedQueues')),
        authority: ['MANAGE_QUEUES'],
    },
    {
        key: 'Flagged Surveys',
        path: 'flagged-surveys',
        component: lazy(() => import('@/pages/FlaggedSurveys/FlaggedSurveys')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Lawyer Tool',
        path: 'lawyer-tool',
        component: lazy(() => import('@/pages/LawyerToolList/LawyerToolList')),
        authority: ['READ_LAWYER'],
    },
    {
        key: 'Lawyer Dashboard',
        path: 'lawyer-dashboard',
        component: lazy(() => import('@/pages/LawyerDashboard/LawyerDashboard')),
        authority: ['READ_LAWYER_DASHBOARD'],
    },
    {
        key: 'Partner RFP Search Form',
        path: 'partner-rfp-search-form',
        component: lazy(() => import('@/pages/PartnerRfpSearchForm/PartnerRfpSearchForm')),
        authority: ['PARTNER_RFP_SEARCH'],
    },
    {
        key: 'Business Max Selection',
        path: 'business-max-selection',
        component: lazy(() => import('@/pages/BusinessMaxSelectionList/BusinessMaxSelectionList')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Related Business Types',
        path: 'related-bus-types',
        component: lazy(() => import('@/pages/RelatedBusTypeList/RelatedBusTypeList')),
        authority: ['READ_RELATED_BUS_TYPE'],
    },
    {
        key: 'Lead Price Simulation',
        path: 'lead-price-simulation',
        component: lazy(() => import('@/pages/LeadPriceSimulationPage/LeadPriceSimulationPage')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Lead Simulation',
        path: 'lead-simulation',
        component: lazy(() => import('@/pages/LeadSimulationPage/LeadSimulationPage')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Marketing Renewal List',
        path: 'marketing-renewal-list',
        component: lazy(() => import('@/pages/MarketingRenewalList/MarketingRenewalListPage')),
        authority: ['READ_INVOICE'],
    },
    {
        key: 'Affiliation Stats',
        path: 'affiliation-stats',
        component: lazy(() => import('@/pages/AffiliationStats/AffiliationStatsPage')),
        authority: ['VIEW_CHARTS_PLUS'],
    },
    {
        key: 'Premium Category Top Yearly',
        path: 'premium-category-topyearly',
        component: lazy(() => import('@/pages/PremiumCategoryTopYearly/PremiumCategoryTopYearly')),
        authority: ['VIEW_CHARTS_ADMIN', 'VIEW_CHARTS_PLUS'],
    },
    {
        key: 'Ppp Leads Yearly',
        path: 'ppp-leads-yearly',
        component: lazy(() => import('@/pages/PppLeadsYearly/PppLeadsYearly')),
        authority: ['VIEW_CHARTS_ADMIN', 'VIEW_CHARTS_PLUS'],
    },
    {
        key: 'Monthly GlobalRfps',
        path: 'monthly-global-rfps',
        component: lazy(() => import('@/pages/MonthlyGlobalRfps/MonthlyGlobalRfps')),
        authority: ['VIEW_CHARTS_ADMIN', 'VIEW_CHARTS_PLUS'],
    },
    {
        key: 'Sea Channel Stats',
        path: 'sea-channel-stats',
        component: lazy(() => import('@/pages/SeaChannelStats/SeaChannelStatsPage')),
        authority: ['VIEW_CHARTS_PLUS'],
    },
    {
        key: 'Accepted Multiples',
        path: 'accepted-multiples',
        component: lazy(() => import('@/pages/AcceptedMultiples/AcceptedMultiples')),
        authority: ['VIEW_CHARTS'],
    },
    {
        key: 'Protests by affiliate',
        path: 'aff-protests',
        component: lazy(() => import('@/pages/AffProtests/AffProtests')),
        authority: ['VIEW_CHARTS'],
    },
    {
        key: 'Monthly Targets',
        path: 'monthly-targets',
        component: lazy(() => import('@/pages/MonthlyTargets/MonthlyTargets')),
        authority: ['VIEW_CHARTS_PLUS'],
    },
    {
        key: 'Invoices By Vendor',
        path: 'invoices-by-vendor',
        component: lazy(() => import('@/pages/InvoicesByVendor/InvoicesByVendorPage')),
        authority: ['VIEW_CHARTS_PLUS'],
    },
    {
        key: 'Supplier Marketing Dashboard',
        path: 'gsupplier-marketing',
        component: lazy(() => import('@/pages/SupplierMarketingDashboard/SupplierMarketingDashboard')),
        // A vendor gets in with VIEW_SPM_DASHBOARD but stays pinned on their own figures (the backend
        // forces it). The two cross-vendor pages below keep VIEW_CHARTS_PLUS on their own.
        authority: ['VIEW_CHARTS_PLUS', 'VIEW_SPM_DASHBOARD'],
    },
    {
        key: 'Supplier Marketing Vendors',
        path: 'gsupplier-marketing2',
        component: lazy(() => import('@/pages/SupplierMarketingVendors/SupplierMarketingVendors')),
        authority: ['VIEW_CHARTS_PLUS'],
    },
    {
        key: 'Supplier Marketing Affiliates',
        path: 'gsupplier-marketing-aff',
        component: lazy(() => import('@/pages/SupplierMarketingAffiliates/SupplierMarketingAffiliates')),
        authority: ['VIEW_CHARTS_PLUS'],
    },
    {
        key: 'Zip Distance',
        path: 'zip-distance',
        component: lazy(() => import('@/pages/ZipDistance/ZipDistance')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: "TrustPilot Reviews",
        path: 'trustpilot-reviews',
        component: lazy(() => import('@/pages/TrustPilotReviews/TrustPilotReviewList')),
        authority: ["READ_TRUSTPILOT_REVIEW"]
    },
    {
        key: 'PPP Suppliers Per Region',
        path: 'ppp-suppliers-region',
        component: lazy(() => import('@/pages/PppSuppliersRegion/PppSuppliersRegion')),
        authority: ['READ_PRICING'],
    },
    {
        key: 'Sales work dashboard',
        path: 'sales-work-dashboard',
        component: lazy(() => import('@/pages/SalesWorkDashboard/SalesWorkDashboard')),
        authority: ['READ_OPPORTUNITIES'],
    },

    {
        key: 'Rappel Last Letter',
        path: 'rappel-last-letter',
        component: lazy(() => import('@/pages/RappelLastLetter/RappelLastLetter')),
        authority: ['READ_RAPPEL'],
    },
    {
        key: 'Call calendar',
        path: 'call-calendar',
        component: lazy(() => import('@/pages/CallCalendar/CallCalendar')),
        authority: ['READ_USER'],
    },
    {
        key: 'Call calendar overview',
        path: 'call-calendar-overview',
        component: lazy(() => import('@/pages/CallCalendar/CallCalendar')),
        authority: ['READ_USER'],
    },
    {
        key: 'Sales current dashboard',
        path: 'sales-current-dashboard',
        component: lazy(() => import('@/pages/SalesCurrentDashboard/SalesCurrentDashboard')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Sales opportunities dashboard',
        path: 'sales-opportunities-dashboard',
        component: lazy(() => import('@/pages/SalesOpportunitiesDashboard/SalesOpportunitiesDashboard')),
        authority: ['CAN_LOGIN'],
    },
    {
        key: 'Sales vendor dashboard',
        path: 'sales-vendor-dashboard',
        component: lazy(() => import('@/pages/SalesVendorDashboard/SalesVendorDashboard')),
        authority: ['READ_OPPORTUNITIES', 'VIEW_ALL_OPPORTUNITIES'],
    },
    {
        key: 'Revenues per premium partner',
        path: 'revenues-per-premium-partner',
        component: lazy(() => import('@/pages/RevenuesPerPremiumPartner/RevenuesPerPremiumPartner')),
        authority: ['VIEW_CHARTS_ADMIN', 'VIEW_CHARTS_PLUS'],
    },
    {
        key: 'Payments dashboard',
        path: 'payments-dashboard',
        component: lazy(() => import('@/pages/PaymentsDashboard/PaymentsDashboard')),
        authority: ['VIEW_CHARTS_ADMIN'],
    },
    {
        key: 'Integration errors',
        path: 'integration-errors',
        component: lazy(() => import('@/pages/IntegrationErrors/IntegrationErrors')),
        authority: ['READ_USER'],
    },

];
